// extracted by mini-css-extract-plugin
export default {"wrapper":"tags_wrapper__cBTWo","tag":"tags_tag__FH-dn","title":"tags_title__a8vfP","value":"tags_value__mL32B"};